import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Close from '../../../../../images/sessions/close.svg';
import Hamburger from '../../../../../images/sessions/hamburger.svg';
import Logo from '../../../../../images/sessions/logo.svg';
import TabContainer from './TabContainer';
import Notes from './Notes';
import AudioDifficulties from './AudioDifficulties';
import Chat from './chat';
import DeviceSettings from './DeviceSettings';

function Sidebar({
  appointment,
  user,
  deviceSettings = null,
  liveCaptions = null,
  locale = 'en',
}) {
  const [activeTab, setActiveTab] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isCouplesGuest, setIsCouplesGuest] = useState(false);

  useEffect(() => {
    if (appointment.id && user.id) {
      if (
        appointment.provider_type === 'couples' &&
        user.id === appointment.couples_appointment_detail.guest.id
      ) {
        setIsCouplesGuest(true);
      }
    }
    // Match class componentDidMount: run once on mount only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeSidebar = () => {
    setSidebarOpen(false);
    setActiveTab(0);
    document.getElementById('sidebar').style.width = '62px';
  };

  const openSidebar = () => {
    setSidebarOpen(true);
    document.getElementById('sidebar').style.width = '400px';
  };

  const handleChange = index => {
    setActiveTab(index);
  };

  const isVonage = appointment.video_provider === 'vonage';

  const renderCurrentTab = () => {
    switch (activeTab) {
      case 0:
        return <Chat />;
      case 1:
        return isCouplesGuest ? <AudioDifficulties /> : <Notes />;
      case 2:
        return <AudioDifficulties />;
      case 3:
        return isVonage && deviceSettings ? (
          <DeviceSettings
            appointment={appointment}
            controller={deviceSettings.controller}
            hasVideoSource={deviceSettings.hasVideoSource}
            liveCaptions={liveCaptions}
            locale={locale}
          />
        ) : (
          <div />
        );
      default:
        break;
    }

    return <div />;
  };

  return (
    <div id="sidebar" className="video-sidebar">
      {sidebarOpen ? (
        <div className="sidebar-container">
          <div className="sidebar-logo">
            <Logo />
            <Close className="sidebar-pointer" onClick={closeSidebar} />
          </div>
          <div className="sidebar-tab-wrapper">
            <TabContainer
              activeTab={activeTab}
              handleChange={handleChange}
              isCouplesGuest={isCouplesGuest}
              isVonage={isVonage}
            />
          </div>
          <div className="sidebar-contents-wrapper">
            {renderCurrentTab()}
          </div>
        </div>
      ) : (
        <div className="sidebar-hamburger sidebar-pointer">
          <Hamburger onClick={openSidebar} />
        </div>
      )}
    </div>
  );
}

Sidebar.propTypes = {
  user: PropTypes.object.isRequired,
  appointment: PropTypes.object.isRequired,
  deviceSettings: PropTypes.shape({
    controller: PropTypes.object.isRequired,
    hasVideoSource: PropTypes.bool.isRequired,
  }),
  liveCaptions: PropTypes.shape({
    available: PropTypes.bool.isRequired,
    isEnabled: PropTypes.bool.isRequired,
    isStarting: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
  }),
  locale: PropTypes.string,
};

export default Sidebar;
